var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.9C6.46444 1.9 5.625 2.75066 5.625 3.8H9.375C9.375 2.75066 8.53556 1.9 7.5 1.9ZM4.25168 1.9C4.90008 0.76418 6.11194 0 7.5 0C8.88806 0 10.1 0.76418 10.7483 1.9H12.1875C13.7408 1.9 15 3.17599 15 4.75V16.15C15 17.7241 13.7408 19 12.1875 19H2.8125C1.2592 19 0 17.7241 0 16.15V4.75C0 3.17599 1.2592 1.9 2.8125 1.9H4.25168ZM3.75 3.8H2.8125C2.29474 3.8 1.875 4.22533 1.875 4.75V16.15C1.875 16.6747 2.29474 17.1 2.8125 17.1H12.1875C12.7053 17.1 13.125 16.6747 13.125 16.15V4.75C13.125 4.22533 12.7053 3.8 12.1875 3.8H11.25C11.25 4.84934 10.4106 5.7 9.375 5.7H5.625C4.58947 5.7 3.75 4.84934 3.75 3.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.010c427eea827efb54bdcc40bf605744.svg";
export { ForwardRef as ReactComponent };